import type { CSSProperties, ReactNode } from 'react';
import { theme as antdTheme } from 'antd';
import { typeScale, space, tracking } from './tokens';

/**
 * The uppercase "eyebrow" label: small, letter-spaced, secondary-color text
 * that captions a section (Lead Detail panels, user-detail panels, the
 * StatCallout value). It was duplicated verbatim as a local `SectionHeader` in
 * both packages/screens/leadDetail and apps/portal/components — the same
 * component twice — so it lives here once now.
 *
 * NB: distinct from the Title-style `SectionHeader` also exported from
 * @viq-admin/ui (an antd `Typography.Title` the console resource pages use).
 * This is a caption eyebrow, that is a heading; they only share a former name.
 *
 * `style` merges last, for the rare caller that needs a different margin or
 * weight — e.g. StatCallout, whose label sits UNDER its value rather than above
 * a section.
 */
export function EyebrowLabel({
  children,
  style,
}: {
  children: ReactNode;
  style?: CSSProperties;
}) {
  const { token } = antdTheme.useToken();
  return (
    <div
      style={{
        textTransform: 'uppercase',
        fontSize: typeScale.caption,
        letterSpacing: tracking.eyebrow,
        color: token.colorTextSecondary,
        fontWeight: 600,
        marginBottom: space.md,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
